import React, {useState} from 'react'
import { AutoComplete } from 'antd'
import * as API from '../../../api'

import './index.less'
interface ContentTagListType {
	value: string;
	tagkey: string;
	name: string;
}
interface TagListType {
	content: string;
	[propName: string]: any;
}
interface TagDataType {
	id: number;
	tagKey: string;
	name: string;
	values: TagListType[];
	direction?: string;
}
interface TagSelectProps {
	tagkey: string;
	value: string;
}
interface SearchSelectProps {
	tagkey: string;
	value: string;
	name: string;
}
interface ConditionListType {
	value: string;
	key: string;
	condition: string;
}
interface ParamTypeProps {
	index: number;
	width?: string;
	defaultValue: string;
}
class AddTag extends React.Component<ConditionListType> {
	constructor(props) {
		super(props)
		this.addCondition = this.addCondition.bind(this)
		this.reset = this.reset.bind(this)
		this.getConditionList = this.getConditionList.bind(this)
	}
	state = {
		conditionList: [],
		contentTagList: [],
		firstTag: {
			value: '',
			key: '',
			condition: 'filter'
		},
	}
	reset() {
		const { firstTag, conditionList } = this.state
		firstTag.value = ''
		firstTag.key = ''
		conditionList.forEach((item: object) => {
			item['value'] = ''
			item['key'] = ''
		})
		this.setState({
			conditionList,
			firstTag
		})
	}
	componentDidMount() {
		this.getTagList()

	}
	async getTagList() {
		const res = await API.getAllTags()
		if(res.code === 0) {
			const data = res.data
			const contentTagList: ContentTagListType[] = []
			data.forEach((item: TagDataType) => {
				const tagList: TagListType[] = item.values
				tagList.forEach(tag => {
					contentTagList.push({
						value: tag.content, // 标签
						tagkey: item.tagKey,
						name: item.name // 分类
					})
				})
			})
			this.setState({
				contentTagList
			})
		}
	}
	switchCondition(idx: number) {
		const conditionList: ConditionListType[] = [...this.state.conditionList]
		conditionList[idx].condition = conditionList[idx].condition === 'filter' ? 'should' : 'filter'
		this.setState({
			conditionList
		})
	}
	addCondition() {
		const conditionList: ConditionListType[] = [...this.state.conditionList]
		conditionList.push({ condition: 'filter', value: '', key: ''})
		this.setState({
			conditionList
		})
	}
	// TODO 标签 是哪个字段 及 选择传值确认  条件值
	delCondition(idx: number) {
		const conditionList = [...this.state.conditionList]
		conditionList.splice(idx, 1)
		this.setState({
			conditionList
		})
	}
	getConditionList(type) {
		const { firstTag, conditionList } = this.state
		let condition = {}
		if(firstTag.value === '') {
			conditionList.forEach((item: ConditionListType, index) => {
				if(item.value === '') {
					conditionList.splice(index,1)
				} else {
					condition = this.createTerm(item.key, item.value)
					return
				}
			})
		} else {
			condition = this.createTerm(firstTag.key, firstTag.value)
		}
		conditionList.forEach((item: ConditionListType) => {
			if(item.value) {
				const secondition = this.createTerm(item.key, item.value)
				condition = this.aggregationFilter(condition, secondition, item.condition)
			}
		})
		// console.log('condition', condition)
		if(type !== 'fun') {
			return condition
		}
	}
	aggregationFilter(term1: object, term2: object, condition: string) {
		const list = [term1, term2]
		const boolJson = {}
		boolJson[condition] = list
		const result = {
			bool: boolJson
		}
		return result
	}
	createTerm(key: string, value: string) {
		const termJson = {}
		termJson[key] = value
		return {
			bool:{
				filter: {
					term: termJson
				}
			}
		}
	}
	render() {
		const { conditionList, contentTagList, firstTag } = this.state
		const Complete: React.FC<ParamTypeProps> = (param) => {
			const [options, setOptions] = useState<SearchSelectProps[]>([])
			const searchResult = (searchText: string) => {
				const searchResult: ContentTagListType[] = []
				contentTagList.forEach((item: ContentTagListType) => {
					if(item.value.indexOf(searchText) > -1) {
						searchResult.push(item)
					}
				})
				return searchResult
			}
			const handleSearch = (value: string) => {
				setOptions(value ? searchResult(value) : [])
			}
			const onSelect = (value: string, options: TagSelectProps) => {
				// console.log('onSelect', value, options)
				// 10000 第一个标签不能删除 特殊处理
				if(param.index !== 10000) {
					conditionList[param.index].value= options.value
					conditionList[param.index].key= options.tagkey
					this.setState({
						conditionList
					})
				} else {
					firstTag.value= options.value
					firstTag.key= options.tagkey
				}
			}
			const onChange = (value: string) => {
				if(value === '') {
					if(param.index === 10000) {
						firstTag.value = ''
					} else {
						conditionList[param.index].value = ''
					}
				}
			}

			return (
				<AutoComplete
					dropdownMatchSelectWidth={252}
					style={{ width: param.width }}
					options={options}
					onSelect={onSelect}
					onSearch={handleSearch}
					onChange={onChange}
					defaultValue={param.defaultValue}
				>
				</AutoComplete>
			)
		}
		const conditionNode = conditionList.map((item, index) => {
			return (
				<div className={`fl condition ${index === 0 ? 'first' : ''}`} key={index}>
					<span className="condition-label" onClick={this.switchCondition.bind(this, index)}>{item.condition === 'filter' ? '且' : '或'}</span>
					<Complete width="120px" index={index} defaultValue={item.value}/>
					<i onClick={this.delCondition.bind(this, index)}></i>
				</div>
			)
		})
		return (
			<>
				<div className="col fl tag">
					<span className="label w52">标签</span>
					<Complete index={10000} defaultValue={firstTag.value}/>
				</div>
				{conditionNode}
				<div className="fl condition add-condition" onClick={this.addCondition}>
					新增
				</div>
			</>
		)
	}
}

export default AddTag